import { render, staticRenderFns } from "./ExpenseSelector.vue?vue&type=template&id=534bc72d"
import script from "./ExpenseSelector.vue?vue&type=script&lang=js"
export * from "./ExpenseSelector.vue?vue&type=script&lang=js"
import style0 from "./ExpenseSelector.vue?vue&type=style&index=0&id=534bc72d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports